/**
 * "Where we've been" gallery: filters reload the page with ?country=&type=, more
 * items load as the visitor scrolls (the controller answers AJAX requests with just
 * the items), and a <dialog> shows the photo or video. Everything the dialog needs
 * is on the item itself (data-*), so no second request is made.
 */
export function initGalleryPage() {
    const container = document.getElementById('galleryContainer');
    if (!container) {
        return;
    }
    const base = container.dataset.url;
    const sentinel = document.getElementById('scrollSentinel');
    const loading = document.getElementById('loadingIndicator');
    const noMore = document.getElementById('noMoreItems');
    const dialog = document.getElementById('galleryModal');
    const body = document.getElementById('modalContent');
    let page = 1;
    let hasMore = container.dataset.hasMore === '1';
    let busy = false;

    const filterForm = document.getElementById('galleryFilters');
    filterForm?.addEventListener('change', () => filterForm.requestSubmit());

    const params = () => {
        const p = new URLSearchParams(window.location.search);
        p.set('page', String(page + 1));
        return p;
    };

    const loadMore = async () => {
        if (busy || !hasMore) {
            return;
        }
        busy = true;
        if (loading) { loading.hidden = false; }
        try {
            const response = await fetch(`${base}?${params()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' } });
            const html = (await response.text()).trim();
            if (!response.ok || !html) {
                hasMore = false;
            } else {
                page += 1;
                const wrap = document.createElement('div');
                wrap.innerHTML = html;
                [...wrap.children].forEach((child) => container.appendChild(child));
            }
        } catch (e) {
            hasMore = false;
        }
        busy = false;
        if (loading) { loading.hidden = true; }
        if (!hasMore && noMore && container.children.length) { noMore.hidden = false; }
    };

    if (sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { loadMore(); } }, { rootMargin: '400px' }).observe(sentinel);
    }

    container.addEventListener('click', (event) => {
        const item = event.target.closest('[data-gallery-item]');
        if (!item || !dialog || typeof dialog.showModal !== 'function') {
            return;
        }
        const d = item.dataset;
        body.innerHTML = '';
        if (d.type === 'video' && d.video) {
            const link = document.createElement('a');
            link.href = d.video;
            link.target = '_blank';
            link.rel = 'noopener';
            link.className = 'ui-btn ui-btn--primary';
            link.textContent = d.watchLabel || 'Watch the video';
            const img = document.createElement('img');
            img.src = d.image;
            img.alt = d.title || '';
            body.append(img, link);
        } else {
            const img = document.createElement('img');
            img.src = d.full || d.image;
            img.alt = d.title || '';
            body.appendChild(img);
        }
        const caption = document.createElement('div');
        caption.className = 'ui-dialog__body';
        const title = document.createElement('div');
        title.className = 'ui-h4';
        title.textContent = d.title || '';
        const meta = document.createElement('p');
        meta.className = 'ui-muted ui-small';
        meta.textContent = [d.location, d.description].filter(Boolean).join(' · ');
        caption.append(title, meta);
        body.appendChild(caption);
        dialog.showModal();
    });
    dialog?.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) { dialog.close(); } });
}
